import { GeneralSettingsContainer } from '@/modules/Settings';

export const GeneralSettings = (): JSX.Element => <GeneralSettingsContainer />;

export default GeneralSettings;
